import { GRAPH_TIMESPANS } from './constants';

export function getGradient(
  timespan: keyof typeof GRAPH_TIMESPANS,
  ctx: CanvasRenderingContext2D
) {
  const gradient = ctx.createLinearGradient(0, 0, ctx.canvas.width, 0);

  switch (timespan) {
    case GRAPH_TIMESPANS.monthly:
      gradient.addColorStop(0, '#FC1C74');
      gradient.addColorStop(0.5, '#FD5441');
      gradient.addColorStop(1, '#FD7622');
      break;
    case GRAPH_TIMESPANS.quarterly:
      gradient.addColorStop(0, '#46CAEF');
      gradient.addColorStop(1, '#ACE7F8');
      break;
  }

  return gradient;
}
